const getRuntimeConfig = () =>
  ({
    isLocal: process.env.APP_BASE_URL?.includes('localhost'),
    isProduction: process.env.STAGE === 'prod',
    stage: process.env.STAGE,
    application: {
      namespace: process.env.APP_NAMESPACE,
      baseUrl: process.env.APP_BASE_URL
    },
    api: {
      global: process.env.API_GLOBAL_BASE_URL,
      orderBack: process.env.ORDER_BACK_API_URL,
      rest: process.env.API_REST_URL,
      extras: process.env.API_EXTRAS_BASE_URL
    },
    dato: {
      baseUrl: process.env.DATO_BASE_URL,
      previewUrl: process.env.DATO_PREVIEW_BASE_URL,
      token: process.env.DATO_TOKEN
    },
    build: {
      mode: process.env.NODE_ENV
    },
    feature: {
      showNewSupportDrawer: process.env.SHOW_SUPPORT_DRAWER_NEW === 'true',
      newExtraOrderDetails: process.env.NEW_EXTRA_ORDER_DETAILS === 'true',
      showFlatOrderListV2: process.env.SHOW_FLAT_ORDER_LIST_V2 === 'true'
    }
  }) as const;

export type EnvConfig = ReturnType<typeof getRuntimeConfig>;

export const config = getRuntimeConfig();
